<script setup lang="ts">
/**
 * CR-Monogramm-Marke fuer Partroom (CR-Rebrand).
 *
 * <p>Vorher: handgezeichnetes Inline-SVG (Zahnrad + Spross). Mit dem
 * Rebrand (siehe {@code design_handoff_cr_rebrand/README.md}) ist die
 * Marke ein freigestelltes CR-Monogramm — amberfarbenes „C" + graues
 * „R". Da die Vorlage als Rastergrafik geliefert wurde (PNG/JPG, keine
 * Vektor-Quelle), bindet diese Komponente die PNGs via {@code <img>} ein
 * und waehlt anhand der Hintergrund-Helligkeit die richtige Variante:
 *
 * <ul>
 *   <li>{@code variant="dark"} — fuer dunkle Flaechen (Sidebar,
 *       Login-Brand-Panel). Das „R" ist auf {@code #c6cbd4} aufgehellt,
 *       damit es nicht im Steel-Grund versinkt. Default.</li>
 *   <li>{@code variant="light"} — Original ({@code „R"} dunkel) fuer
 *       helle Flaechen wie das mobile Login-Mini-Logo.</li>
 * </ul>
 *
 * <p>Beide Varianten haben Seitenverhaeltnis ~2.30:1 (788x342). Container
 * sollten entsprechend dimensioniert sein — quadratische Container
 * stauchen das Monogramm sichtbar. Die Komponente fuellt den Container
 * mit {@code object-fit: contain}; das Ausrichten (links/zentriert)
 * uebernimmt der Aufrufer via {@code object-position}.
 */

defineProps<{
  variant?: 'dark' | 'light'
}>()
</script>

<template>
  <img
    :src="(variant ?? 'dark') === 'light' ? '/cr-logo.png' : '/cr-logo-dark.png'"
    alt="Partroom"
    draggable="false"
  />
</template>

<style scoped>
img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: contain;
  user-select: none;
}
</style>
